// ErrorState.tsx

import React from 'react';
import { useMediaQuery } from '@/lib/hooks/useMediaQuery';

const EDS3_BREAKPOINT_XL = 1280;
const MIN_WIDTH_BREAKPOINT = `(min-width: ${EDS3_BREAKPOINT_XL}px)`;

export const ErrorState = () => {
  const isMenuExpanded = useMediaQuery(MIN_WIDTH_BREAKPOINT);

  return (
    <div
      style={{
        // Not ideal, but for simplicity, just hide the menu on smaller screens
        display: isMenuExpanded ? 'flex' : 'none',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#FFFFFF',
        borderRight: '1px solid #EDEDED',
        height: '100vh',
        width: '272px',
        padding: '24px',
        gap: '16px',
        fontFamily: `ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif`,
      }}
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
          fill="#EDEDED"
        />
        <path
          d="M31.4882 32.7193L15.2727 16.5038C15.1343 16.3655 15.0635 16.194 15.0602 15.9895C15.057 15.785 15.1272 15.6052 15.2707 15.45C15.4272 15.2949 15.6061 15.2173 15.8074 15.2173C16.0086 15.2173 16.1867 15.2949 16.3419 15.45L32.5572 31.6653C32.706 31.8141 32.7794 31.9882 32.7774 32.1875C32.7756 32.3869 32.6971 32.5648 32.5419 32.7213C32.3867 32.8648 32.2111 32.9391 32.0149 32.9443C31.8187 32.9493 31.6432 32.8743 31.4882 32.7193ZM24.4419 32.05C22.0151 32.05 19.9917 31.7074 18.3717 31.022C16.7518 30.3369 15.9419 29.4808 15.9419 28.4538V18.55C15.9419 18.1807 16.0749 17.829 16.3409 17.495C16.6069 17.1612 16.9777 16.85 17.4534 16.5615L22.7727 21.8808C21.6945 21.7988 20.7016 21.636 19.7939 21.3923C18.8861 21.1486 18.1021 20.8345 17.4419 20.45V23.998C18.2599 24.4814 19.2739 24.8545 20.4839 25.1173C21.6941 25.3801 23.0134 25.5115 24.4419 25.5115C24.7686 25.5115 25.0871 25.5074 25.3974 25.499C25.7077 25.4907 26.0181 25.4699 26.3284 25.4365L27.6457 26.7538C27.1432 26.8448 26.6237 26.9105 26.0872 26.951C25.5505 26.9914 25.0021 27.0115 24.4419 27.0115C23.0134 27.0115 21.6941 26.8801 20.4839 26.6173C19.2739 26.3545 18.2599 25.9814 17.4419 25.498V28.55C17.6881 29.091 18.5037 29.5596 19.8889 29.9558C21.2742 30.352 22.7919 30.55 24.4419 30.55C25.5919 30.55 26.6932 30.4465 27.7457 30.2395C28.7983 30.0324 29.6618 29.7673 30.3362 29.4443L31.4304 30.5385C30.6714 31.0039 29.6881 31.3721 28.4804 31.6433C27.2727 31.9145 25.9266 32.05 24.4419 32.05ZM32.9419 18.55V27.725C32.9419 27.9375 32.87 28.1156 32.7262 28.2593C32.5823 28.4031 32.4042 28.475 32.1917 28.475C31.979 28.475 31.8009 28.4031 31.6574 28.2593C31.5137 28.1156 31.4419 27.9375 31.4419 27.725V25.498C31.2137 25.63 30.9727 25.7522 30.7189 25.8645C30.4651 25.9767 30.1932 26.084 29.9034 26.1865C29.7277 26.2507 29.547 26.2398 29.3612 26.1538C29.1752 26.068 29.0502 25.9372 28.9862 25.7615C28.922 25.5859 28.9329 25.4051 29.0189 25.2193C29.1047 25.0335 29.2355 24.9085 29.4112 24.8443C29.7958 24.7315 30.1573 24.6045 30.4957 24.4635C30.8342 24.3225 31.1496 24.1674 31.4419 23.998V20.45C30.7266 20.8719 29.8695 21.2075 28.8707 21.4568C27.872 21.7061 26.7932 21.8596 25.6342 21.9173C25.4278 21.9378 25.2502 21.8788 25.1014 21.7403C24.9527 21.602 24.8682 21.4295 24.8477 21.223C24.8272 21.0167 24.8836 20.8391 25.0169 20.6903C25.1502 20.5416 25.3201 20.457 25.5264 20.4365C26.1021 20.3789 26.7095 20.293 27.3487 20.1788C27.9877 20.0648 28.5877 19.9276 29.1487 19.7673C29.7095 19.6071 30.1977 19.4248 30.6132 19.2203C31.0285 19.0158 31.2952 18.7943 31.4132 18.5558C31.1848 18.0661 30.3377 17.6094 28.8717 17.1855C27.4057 16.7619 25.9291 16.55 24.4419 16.55C23.8252 16.55 23.1961 16.5917 22.5544 16.675C21.9127 16.7584 21.3002 16.8667 20.7169 17C20.5041 17.0539 20.3082 17.0244 20.1294 16.9115C19.9506 16.7987 19.8342 16.6359 19.7804 16.423C19.7266 16.2102 19.7561 16.0144 19.8689 15.8355C19.9817 15.6567 20.1446 15.5404 20.3574 15.4865C20.9714 15.343 21.6214 15.2344 22.3074 15.1605C22.9932 15.0869 23.7047 15.05 24.4419 15.05C26.7906 15.05 28.7944 15.3928 30.4534 16.0783C32.1124 16.7636 32.9419 17.5875 32.9419 18.55Z"
          fill="#737373"
        />
      </svg>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          textAlign: 'center',
        }}
      >
        <p
          style={{
            margin: 0,
            color: '#212121',
            fontSize: '16px',
            fontWeight: 700,
            lineHeight: '20px',
          }}
        >
          Menu is unavailable
        </p>
        <p
          style={{
            margin: 0,
            color: '#737373',
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '18px',
          }}
        >
          We apologise for the inconvenience. Please refresh the page, or
          contact your admin if the error continues.
        </p>
      </div>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          padding: '6px 12px',
          backgroundColor: '#ffffff',
          border: '1px solid #E4E4E4',
          borderRadius: '4px',
          cursor: 'pointer',
          color: '#212121',
          fontSize: '14px',
          fontWeight: 500,
        }}
      >
        Refresh
      </button>
    </div>
  );
};
